import styled from 'styled-components';

import {Column, Row, ColumnW100Div} from './../../common/Layouts/Layouts';

export const WrapperDiv = styled(Column)(
  props => `
    width: 33rem;
    display: flex;
    flex-direction: column;
    background-color: ${props.theme.colors.white.base};
    border-radius: ${props.theme.misc.borderRadius.base};
    box-shadow: 0 2px 14px 0 rgba(0, 0, 0, 0.16);
    position: absolute;
    top: ${props.isSearchWidget ? '5.4rem' : '10.9rem'};
    // left: 44rem;
    z-index: ${props.theme.misc.zIndex.xlarge};
    border-radius: ${props.theme.misc.borderRadius.base};
`,
);

export const ContentWrapperDiv = styled(Row)(
  props => `
  border-bottom: 0.1rem solid ${props.theme.colors.grey.lineGrey};
  padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.base} ${props.theme.spacing.nospacing} ${props.theme.spacing.base};
  align-items: center;
`,
);

export const ContentItemWrapperDiv = styled(Column)(
  props => `
    width: 100%;
    display: flex;
    flex-direction: row;
    padding: 0 0 ${props.theme.spacing.large.l20};
    align-items: center;
`,
);

export const ContentItemTextWrapperSpan = styled.span(
  props => `
  color: ${props.theme.colors.grey.base};
  padding: ${props.theme.spacing.base};
  font-size: ${props.theme.font.large.font16};
  font-weight: ${props.theme.font.fontWeight.bold};
  text-transform: ${props.theme.font.textTransform.upper};
`,
);

export const ContentItemConditionTextWrapperSpan = styled.span(
  props => `
  padding-left: ${props.theme.spacing.small.s5};
  font-size: ${props.theme.font.base};
  font-weight: normal;
`,
);

export const ContentActionWrapperDiv = styled(Row)(
  props => `
  position: absolute;
  right: 2rem;
  align-items: center;
  justify-content: space-between;
  padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.base};
  background-color: white;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.13);
  border-radius: ${props.theme.misc.borderRadius.base};
  width: 10.5rem;
  height:4rem;
`,
);

export const ContentActionValueWrapperSpan = styled.span(
  props => `
  font-size: ${props.theme.font.large.font22};
  color: ${props.theme.colors.black.base};
  font-family: ${props.theme.font.fontFamily};
  font-weight: bold;
`,
);

export const ContentActionIconWrapperSpan = styled.span(
  props => `
  font-size: 3rem;
  padding: 0 ${props.theme.spacing.small.s5};
  color: ${props.theme.colors.grey.base};
  font-family: ${props.theme.font.fontFamily};
  // position:relative;
  // top:-${props.theme.spacing.small.s3};
  // font-weight: bold;
  cursor: pointer;
`,
);

export const ButtonWrapperDiv = styled(ColumnW100Div)(
  props => `
  align-items: flex-end;
  padding: ${props.theme.spacing.base};
  border-top: 1px solid ${props.theme.colors.blue.bgBlue};
`,
);

export const ButtonWrapper = styled.button(
  props => `
    display: flex;
    cursor: pointer;
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l35};
    font-family: ${props.theme.font.fontFamily};
    font-weight: bold;
    text-transform: uppercase;
    color: ${props.theme.colors.white.base};
    font-size: ${props.theme.font.large.font14};
    border: none;
    border-radius: 34px;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
    background-image: linear-gradient(98deg, #53b2fe 2%, #065af3 129%);
`,
);

export const ContentActionDropdownWrapper = styled(Row)(
  props => `
  align-items: center;
  justify-content: space-between;
  padding: ${props.theme.spacing.nospacing} ${props.theme.spacing.large.l20};
  background-color: white;
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.13);
  border-radius: 4rem;
  width: 10.5rem;
  height:4rem;
`,
);

export const ChildDropdownWrap = styled.ul(
  props => `
  z-index: ${props.theme.misc.zIndex.small};
  overflow: scroll;
  height: 20rem;
  display:flex;
  flex-direction:column;
  position:absolute;
  margin-top: 5.5rem;
  width: 9rem;
  background: ${props.theme.colors.white.base};
  box-shadow:  0 .1rem .4rem 0 ${props.theme.colors.shadow.base};
  border-radius: ${props.theme.misc.borderRadius.base};
  color: ${props.theme.colors.goBrand.blue};
  overflow: scroll;
  height: 20rem;

  >li {
    padding: ${props.theme.spacing.base} ${props.theme.spacing.large.l15};
    text-align:center;
    color: ${props.theme.colors.goBrand.blue};
    font-weight:bold;
    font-size: ${props.theme.font.large.font14};
    font-family: ${props.theme.font.fontFamily};
    border-bottom: 1px solid ${props.theme.colors.blue.bgBlue};
    cursor: pointer;

  &:last-child{
    border-bottom:none;
  }
`,
);

export const ChildAgeWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    align-items: center;
    padding: 0 ${props.theme.spacing.large.l15};
    border-top:1px solid ${props.theme.colors.grey.lighte7};
    flex-wrap: wrap;
  `
);

export const ChildAgeWrapperDiv = styled.div(
  props => `
    width:33%;
    display: flex;
    flex-direction: column;
    padding:${props.theme.spacing.base} 0;
  `
);

export const ChildAgeTextSpan = styled.p(
  props =>`
    font-size: ${props.theme.font.small.font11};
    color: ${props.theme.colors.black.base};
    text-transform: uppercase;
  `
);

export const ChildAgeDropdownWrapper = styled.div(
  props => `
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${props.theme.spacing.small.s7} ${props.theme.spacing.base};
  background-color: white;
  box-shadow: 0 0px 6px 0 rgba(0,0,0,0.2);
  border-radius: ${props.theme.misc.borderRadius.base};
  height: 3.2rem;
  align-self: flex-start;
  margin-top: ${props.theme.spacing.small.s7};
  min-width: 6rem;
  `
);

export const ChildAgeValueSpan = styled.p(
  props => `
    font-size: ${props.theme.font.large.font14};
    color: ${props.theme.colors.grey.base};
    font-weight: ${props.theme.font.fontWeight.bold};
  `
);

export const ChildAgeIconWrapperSpan = styled.a(
  props => `
    display: flex;
  `
)
